var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.values,"must-sort":"","dense":"","loading-text":"Cargando..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }